import {IHostingInfoState} from "../reducers/hosting-info.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getInfoHostingState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.hostingInfo);

export const getInfo = (websiteId: number) => createSelector(getInfoHostingState,
  (state: IHostingInfoState) =>
    (state.entities[websiteId] && state.entities[websiteId].entities) ? state.entities[websiteId].entities : null
);


export const getInfoMap = (websiteId: number) => createSelector(getInfoHostingState,
  (state: IHostingInfoState) =>
    state.entities[websiteId]
);


export const getInfoLoading = (websiteId: number) => createSelector(getInfoHostingState,
  (state: IHostingInfoState) =>
    state.entities[websiteId].loading
);

export const getInfoLoaded = (websiteId: number) => createSelector(getInfoHostingState,
  (state: IHostingInfoState) =>
    state.entities[websiteId] ? state.entities[websiteId].loaded : false
);
